import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export const deleteProductDate = (id: number) => {
  return restApiClient.url(constructApiUrl(API.products.deleteProductDate.url, { id })).delete()
}
